import './NewReel.sass';

import React, { FC, useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { Button, Header, InfoBlock, Placeholder, ScrollView } from '$uikit';
import { attachActions } from '$store/attach';
import { showModal } from '$navigation/helper';
import { toastActions } from '$store/toast';
import { useTranslator } from '$hooks';

export const NewReel: FC = () => {
  const dispatch = useDispatch();
  const t = useTranslator();

  const handleVideoChange = useCallback(
    ({ target }) => {
      if (!target.files.length) {
        return;
      }
      const file = target.files[0];
      const video = document.createElement('video');
      video.src = URL.createObjectURL(file);
      video.onloadedmetadata = () => {
        if (video.duration > 30) {
          return dispatch(toastActions.setToastFail(t('reels_add_long_error')));
        }

        if (video.width > video.height) {
          return dispatch(toastActions.setToastFail(t('reels_add_vertical_error')));
        }

        dispatch(
          attachActions.uploadVideo({
            pickerId: 'reel',
            file,
            dispatch,
            limit: 100,
          }),
        );
        dispatch(attachActions.setIsAdditionalModalOpened(true));
        showModal('upload_video');
      };
    },
    [t],
  );

  return (
    <>
      <Header showCloseButton />
      <ScrollView>
        <Placeholder
          centered
          title={t('reels_add_title')}
          actions={
            <div className="NewReel__upload_wrap">
              <Button>{t('reels_add_choose')}</Button>
              <input
                type="file"
                accept="video/*"
                className="NewReel__upload_input"
                onChange={handleVideoChange}
              />
            </div>
          }
        >
          <InfoBlock type="warning">{t('reels_add_caption_warning')}</InfoBlock>
          <div style={{ marginTop: 16 }}>{t('reels_add_caption')}</div>
        </Placeholder>
      </ScrollView>
    </>
  );
};
